"use client"

import * as React from "react"
import {
  SquareTerminal,
  Users,
  Building2,
  Bot,
  BarChart3,
  Shield,
  Layers,
  BarChart2,
} from "lucide-react"
import Logo from './Logo'

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import { TeamSwitcher } from "@/components/team-switcher"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar"
import { useAuthStore } from "@/stores/auth-store"

// Navigation items (v1-only)
const navMain = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: SquareTerminal,
    isActive: true,
  },
  {
    title: "Stats",
    url: "/stats",
    icon: BarChart2,
  },
  {
    title: "Analytics",
    url: "/analytics",
    icon: BarChart3,
  },
  {
    title: "Users",
    url: "/users",
    icon: Users,
  },
  {
    title: "Tenants",
    url: "/tenants",
    icon: Layers,
  },
  {
    title: "Organizations",
    url: "/organizations",
    icon: Building2,
  },
  {
    title: "Agents",
    url: "/agents",
    icon: Bot,
  },
  {
    title: "Allowed Domains",
    url: "/allowed-domains",
    icon: Shield,
  },
]

const data = {
  teams: [
    {
      name: "SAIF Admin",
      logo: Logo,
      plan: "v1-only (lean)",
    },
  ],
  navMain,
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user } = useAuthStore()
  
  const userData = user ? {
    name: user.name || user.email,
    email: user.email,
    avatar: "",
  } : {
    name: "Guest",
    email: "guest@example.com",
    avatar: "",
  }

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher teams={data.teams} />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
        {/* <NavProjects projects={data.projects} /> */}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={userData} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
